import { Helmet } from 'react-helmet';
import { Box, Container, Typography } from '@material-ui/core';
import React from 'react';
import MainNavbar from './MainNavbar';

const Content = ({ title, children, userStore, customMenu }) => (
  <>
    <Helmet>
      <title>{title}</title>
    </Helmet>
    <MainNavbar userStore={userStore} title={title} customMenu={customMenu} />
    <Box sx={{ backgroundColor: 'background.default', minHeight: '100%', py: 3 }}>
      <Container maxWidth="xxl">
        {children}
      </Container>
    </Box>
  </>
)

export default Content;
